// How long a membership plan gives access, in words (see index.ts), with no schema library, so a
// creator site's script stays small.

export function isOngoingPlan(plan: { interval: string; ongoingAccess?: boolean }) {
  return plan.interval === "one_time" && plan.ongoingAccess === true;
}

export function planAccessLabel(plan: {
  manualOnly?: boolean;
  interval: string;
  coverageMonths: number;
  ongoingAccess?: boolean;
}) {
  if (plan.manualOnly) return "Manually granted";
  if (plan.interval === "per_creation") return "Per creation · monthly limit chosen by member";
  return isOngoingPlan(plan)
    ? "Ongoing access · one payment"
    : plan.interval === "one_time"
      ? `${plan.coverageMonths} month${plan.coverageMonths === 1 ? "" : "s"} of access · one payment`
      : `Per ${plan.interval}`;
}
